import app, { Component } from 'apprun';
import { companies, locations } from './api';
import { isStringEqual, isValid } from './utils';
import OB_SelAgentsComponent from './ob-sel-agents';

export default class OB_RLP2RLPComponent extends Component {
  ddlComp = ({ id, optoins, objWithRetAttrib, retAttrib, oninput = null, validate = null }) => {
    if (!oninput) {
      oninput = (e) => {
        objWithRetAttrib[retAttrib] = e.target.value;
      };
    }
    return (
      <div>
        <select id={id} class="form-control" oninput={e => oninput(e)} data-validate={validate ? validate : null}>
          <option value="-1">[Select]</option>
          {optoins.map(p => (
            <option
              value={p.id}
              selected={isStringEqual(p.id, objWithRetAttrib?.[retAttrib])? 'selected': null}>
              {p.value}
            </option>
          ))}
        </select>
        <div id={id + 'ErrMsg'} class="text-danger row"></div>
      </div>
    );
  };

  state = {
    fromBrokerageOptions: [],
    toBrokerageOptions: [],
    fromLocationOptions: [],
    toLocationOptions: [],
    fromCompany: null,
    fromLocation: null,
    toCompany: null,
    toLocation: null
  };
  // prettier-ignore
  view = (state) => {
    if (!state) {return;}

    return (
      <div style={{ width: '400px' }}>
        <h3>  RLP to RLP  </h3>
        <h2>  Companies and Locations  </h2>
        <br/>
        <form id="ob_rlp2rlp_compLocForm">
          <div class="row">
            <span>Select the BROKERAGE FROM which you will transfer agents</span>
            <this.ddlComp id="fromCompany" optoins={state.fromBrokerageOptions} objWithRetAttrib={state} retAttrib="fromCompany" oninput={e => this.run('fromCompanySelectionChanged', e.target.value)} validate="Int-1" />
          </div>
          <br />
          <div class="row">
            <span>Select the LOCATION(s) FROM which you will transfer agents</span>
            <this.ddlComp id="fromLocation" optoins={state.fromLocationOptions} objWithRetAttrib={state} retAttrib="fromLocation" validate="Int-1" />
          </div>

          <br /><br />

          <div class="row">
            <span>Select the BROKERAGE the agents will be transferred TO</span>
            <this.ddlComp id="toCompany" optoins={state.toBrokerageOptions} objWithRetAttrib={state} retAttrib="toCompany" oninput={e => this.run('toCompanySelectionChanged', e.target.value)} validate="Int-1" />
          </div>
          <br />
          <div class="row">
            <span>Select the new PRIMARY LOCATION of the transferred agents</span>
            <this.ddlComp id="toLocation" optoins={state.toLocationOptions} objWithRetAttrib={state} retAttrib="toLocation" validate="Int-1" />
          </div>
          <br/><br/>
        </form>
        <div class="edit-buttons">
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('continue')} >Continue</button>
        </div>
        <div>
          <label class={(state.saveMsg!=='Success')?'text-danger':''}>{state.saveMsg}</label>&nbsp;
        </div>
      </div>
    );
  }

  update = {
    refresh: async (state, newState) => {
      state = { ...state, ...newState };
      if (state.fromBrokerageOptions.length === 0) {
        state.fromBrokerageOptions = await companies.getAllTransferCompanies();
        state.fromBrokerageOptions.sort(function (a, b) {
          return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
        });
        state.fromBrokerageOptions.map(p => (p.value = p.id + ' - ' + p.name));
        state.toBrokerageOptions = [];
      }

      return state;
    },

    fromCompanySelectionChanged: async (state, idx) => {
      state.fromCompany = idx;
      state.fromLocationOptions =
         !state.fromCompany ? [] : await locations.getLocationsByCompanyID(state.fromCompany);
      state.fromLocationOptions.sort(function (a, b) {
        return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
      });
      state.fromLocationOptions.map(p => (p.value = p.id.toString() + ' - ' + p.name));
      state.fromLocationOptions.unshift({ name: 'All', value: 'All', id: 0 });

      if(idx === '-1' ){
        state.toBrokerageOptions = [];
      }else{
        const f = state.fromBrokerageOptions.find(o => o.id === idx);
        if(f.provStateCt === '-1'){
          state.toBrokerageOptions = [];
        }else{
          state.toBrokerageOptions = state.fromBrokerageOptions.filter(p => p.provStateCt === f.provStateCt);
        }
      }
      state.toCompany = '-1';

      return state;
    },

    toCompanySelectionChanged: async (state, idx) => {
      state.toCompany = idx;
      state.toLocationOptions = !state.toCompany? [] : await locations.getLocationsByCompanyID(state.toCompany);
      state.toLocationOptions.sort(function (a, b) {
        return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
      });
      state.toLocationOptions.map(p => (p.value = p.id.toString() + ' - ' + p.name));
      return state;
    },

    continue: (state) => {
      const formName = 'ob_rlp2rlp_compLocForm';
      let valid = isValid(formName);
      if (state.fromCompany && state.fromCompany !== -1 && state.fromCompany === state.toCompany) {
        const errMsgDiv = document.getElementById('toCompanyErrMsg') as HTMLDivElement;
        errMsgDiv.innerHTML = '* from & to companies cannot be same';
        valid = false;
      }
      if (!valid) {return;}
      const from = { company: state.fromCompany, location: state.fromLocation };
      const to = {
        company: state.toCompany,
        location: state.toLocation,
        companyName: state.fromBrokerageOptions.filter(p => p.id === state.toCompany)[0].name
      };
      app.run('#add-panel', {
        id: 'obSelAgents',
        title: 'Onboarding - Select Agents',
        Component: OB_SelAgentsComponent,
        level: 3,
        state: { caller: this, from, to }
      });

      return state;
    },

    'sub-panel-cancelled': (state) => {
      app.run('#clear-panel', 'obSelAgents');
      return state;
    },

    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
